module.exports = __webpack_public_path__ + "5fd5b25f40f21aa40fd50ba05add5a03.woff";